import React, { useEffect, useState } from 'react';

export function useHasClickedOutside(
  ref: React.MutableRefObject<any>,
  callback?: () => void
): boolean {
  const [hasClickedOutside, setHasClickedOutside] = useState<boolean>(false);

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: { target: any }) {
      if (ref.current && !ref.current.contains(event.target)) {
        setHasClickedOutside(true);
        if (!!callback) {
          callback();
        }
      } else {
        setHasClickedOutside(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);

  return hasClickedOutside;
}
